import request from './request'

export function login(data) { return request.post('/auth/login', data) }
export function getCurrentUser() { return request.get('/factory/me') }
export function changePassword(data) { return request.post('/factory/change-password', data) }
